import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 5px 12px 0 0 ;
`;

export default Container;
